import axios from "axios";

export const IMAGE_BASE_URL = process.env.REACT_APP_BASE_URL;
export const ADMIN_IMAGE_URL = process.env.REACT_APP_ADMIN_IMAGE_URL;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const baseURL = process.env.REACT_APP_API_URL;

if (!baseURL || !IMAGE_BASE_URL || !ADMIN_IMAGE_URL || !GOOGLE_MAPS_KEY) {
  console.error("CRITICAL ERROR: Environment variables are not defined.");
}

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("driverToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response handler
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;